import "react-app-polyfill/stable";
import "core-js";

import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./configuration/store";
import "./scss/style.scss";

//fonts
import "./fonts/Roboto/Roboto-Regular.ttf";
import "./fonts/Nunito_Sans/NunitoSans_7pt-Regular.ttf";

import "./i18n";
import { ConfirmDialogProvider } from "./utilities/ConfirmDialogContext";

createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <ConfirmDialogProvider>
    <App />
  </ConfirmDialogProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
